import { connect } from 'react-redux';

import decorate from '../../../utils/decorate';

import { request as load } from '../../../modules/fraud-and-compliance/actions/query';
import { request as update } from '../../../modules/fraud-and-compliance/actions/update';
import { request as openAccount } from '../../../modules/customers/actions/open';

import FraudAndCompliancesTab from './FraudAndCompliancesTab.jsx';

function getId(entity) {
    return entity.get('id');
}

function mapStateToProps(state, props) {
    const { entityKey } = props;
    return {
        user: state.user.get('data', new Map()),
        userId: state.user.getIn([ 'data', 'id' ]),
        status: state.fraudAndCompliance.getIn([ 'collections', entityKey, 'state' ]),
        list: state.fraudAndCompliance.getIn([ 'collections', entityKey, 'items' ]),
        items: state.fraudAndCompliance.get('items', new Map()),
        customers: state.customers.get('list', new Map()).map(c => c.get('value',new Map()))
    };
}

function mapDispatchToProps(dispatch, props) {
    const { entityKey } = props;
    return {
        onLoadRequest: (hotRefresh) => dispatch(load(
            entityKey, 'accountId',
            hotRefresh
        )),
        onAssignRequest: entity => dispatch(update(
            entityKey, 'assign', getId(entity)
        )),
        onUnassignRequest: entity => dispatch(update(
            entityKey, 'unassign', getId(entity)
        )),
        onCancelRequest: entity => dispatch(update(
            entityKey, 'close', getId(entity)
        )),
        onOpenAccountRequest: (id, name, params) => dispatch(openAccount(id, name, params))
    };
}

export default decorate(
    connect(mapStateToProps, mapDispatchToProps),
    FraudAndCompliancesTab
);
